// Main script — imports here are bundled into script.js
import $ from "jquery";
import "../vendors/unison.js";

// header
let allBreakpoints = Unison.fetch.all(),
  currentBreakpoint = "",
  whereToScroll = 0;

// panels — reusable sliding drawer system
// trigger: selector for the element that opens/closes the panel
// panel: selector for the panel element
// options:
//   withOverlay: bool — show a clickable overlay behind the panel, desktop only (default: false)
//   closeBtn: selector — dedicated close element inside/outside the panel
//             for the menu on mobile: close via trigger only, no closeBtn needed
//             for all other panels (cart, search…): pass closeBtn on both mobile and desktop
function initPanel(trigger, panel, options) {
  var defaults = {
    withOverlay: false,
    closeBtn: null,
  };
  var opts = $.extend({}, defaults, options);
  var $trigger = $(trigger);
  var $panel = $(panel);

  // clean up previous bindings before re-init (breakpoint change)
  $trigger.off("click.panel");
  if (opts.closeBtn) {
    $(document).off("click.panel", opts.closeBtn);
  }

  function openPanel() {
    $panel.addClass("open");
    $trigger.addClass("open");
    $("body").addClass("panel-open");
    if (opts.withOverlay) {
      if (!$("#panel-overlay").length) {
        $("body").append('<div id="panel-overlay"></div>');
      }
      $("#panel-overlay").addClass("visible").one("click", closePanel);
    }
  }

  function closePanel() {
    $panel.removeClass("open");
    $trigger.removeClass("open");
    $("body").removeClass("panel-open");
    if (opts.withOverlay) {
      $("#panel-overlay").removeClass("visible");
    }
  }

  $trigger.on("click.panel", function () {
    $panel.hasClass("open") ? closePanel() : openPanel();
  });

  if (opts.closeBtn) {
    $(document).on("click.panel", opts.closeBtn, closePanel);
  }
}

// shell
function initShell(mobile) {
  var headerHeight = $("#header").outerHeight();
  $("main").css("padding-top", headerHeight);
  document.documentElement.style.setProperty("--header-height", headerHeight + "px");
  if (mobile == 1) {
    $("#menu-container")
      .insertAfter("#header")
      .css("padding-top", $("#header").outerHeight())
      .css("padding-bottom", $("#mobile-user-btn").outerHeight() - 1);
    initPanel(".menu-btn", "#menu-container");
  } else {
    $("#menu-container").insertAfter("#logo").css("padding-top", 0);
    $(".menu-btn").off("click.panel");
  }
  // open/close sub-menus
  $("#menu-container .menu-top-level > .toggle").on("click", function () {
    $("#menu-container .menu-top-level > .toggle")
      .not(this)
      .attr("aria-expanded", "false")
      .removeClass("active")
      .next(".sub-menu-container")
      .removeClass("active");
    $(this)
      .toggleClass("active")
      .next(".sub-menu-container")
      .toggleClass("active");
    $(this).attr("aria-expanded", function (i, attr) {
      return attr == "true" ? "false" : "true";
    });
    //$("#search-container .close").click();
  });
  // open/close search form
  // initSearch(mobile);
}
function initSearch(mobile) {
  $(".search-btn").on("click", function () {
    $("#search-container").addClass("open");
    if (mobile == 0) {
      $("#menu-container button.toggle")
        .attr("aria-expanded", "false")
        .removeClass("active")
        .next(".sub-menu-container")
        .removeClass("active");
    }
  });
  $("#search-container .close").on("click", function () {
    $("#search-container").removeClass("open");
  });
}

// Sticky nav
function stickyNav() {
  $(window).on("scroll", function () {
    // console.log("scrolling");
    // console.log("$(this).scrollTop():" + $(this).scrollTop());
    // console.log("$('#header').outerHeight():" + $("#header").outerHeight());
    if ($(this).scrollTop() >= $("#header").outerHeight()) {
      $("#header").addClass("sticky");
      $(".main-nav .sub-menu-container").removeClass("active");
    } else {
      $("#header").removeClass("sticky");
    }
  });
}

// accordions
function initAccordions() {
  $(".accordion-list").each(function () {
    $(this)
      .find("dt")
      .on("click", function () {
        $(this).toggleClass("open");
        $(this).attr("aria-expanded", function (i, attr) {
          return attr == "true" ? "false" : "true";
        });
      });
  });
}

// RWD
Unison.on("change", function (bp) {
  switch (bp.name) {
    case "usn-small":
      initShell(1);
      stickyNav();
      break;
    case "usn-medium":
      initShell(0);
      stickyNav();
      break;
    case "usn-large":
      initShell(0);
      stickyNav();
      break;
    case "usn-xlarge":
      initShell(0);
      stickyNav();
      break;
    case "usn-xxlarge":
      initShell(0);
      stickyNav();
      break;
  }
});

$(document).ready(function () {
  // tiles click
  $(".card").each(function () {
    $(this).on("click", function (e) {
      e.stopPropagation();
      e.preventDefault();
      var link = $(this).find("a").first();
      if (undefined == link) {
        return;
      }
      var url = link.attr("href");
      if (undefined == url) {
        return;
      }
      var target = link.attr("target");
      if ("_blank" == target) {
        window.open(url, "_blank");
        return;
      }
      window.location.href = url;
      return;
    });
  });

  // accordions
  // initAccordions();
});
